import {configureStore, combineReducers, Action, AnyAction, Reducer} from '@reduxjs/toolkit';
// import {configureStore, combineReducers, Action} from '@reduxjs/toolkit';
import thunk, {ThunkAction} from 'redux-thunk';
import storage from 'redux-persist/lib/storage';
import {persistReducer, persistStore} from 'redux-persist';
import authReducer from './auth/authSlice';
import opModelReducer from './operatingModel/operatingModelSlice';
import artifactReducer from './artifacts/artifactSlice';
import {omApi} from './operatingModel/operatingModelApi';
import {searchApi} from './search/searchApi';
import {artifactsApi} from './artifacts/artifactsApi';
import {listenerMiddleware} from './store_init';
import {userApi} from './users/userApiSlice';
import userReducer from './users/userSlice';
import searchReducer from './search/searchSlice';
import appStateReducer from './appState/appStateSlice';
import changeReducer from './change/changeSlice';
import {changeApi} from './change/changeApi';
import {selectedReleaseListener} from './change/selectedReleasesListener';
import registrationReducer from './registration/registrationSlice';
import {registrationApi} from './registration/resgistrationApi';

// ==============================|| REDUX - MAIN STORE ||============================== //
const appReducer = combineReducers({
  auth: authReducer,
  appState: appStateReducer,
  operatingModel: opModelReducer,
  artifacts: artifactReducer,
  user: userReducer,
  search: searchReducer,
  changes: changeReducer,
  registration: registrationReducer,
  [changeApi.reducerPath]: changeApi.reducer,
  [artifactsApi.reducerPath]: artifactsApi.reducer,
  [searchApi.reducerPath]: searchApi.reducer,
  [omApi.reducerPath]: omApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [registrationApi.reducerPath]: registrationApi.reducer,
});

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === 'auth/setLogOut') {
    console.log('clearing local storage state');
    storage.removeItem('persist:elevate');
    // Reset all state
    state = {} as RootState;
  }

  if (action.type === 'auth/setInactiveLogout') {
    // Immutable update to part of the state
    return {
      ...state,
      appState: {
        ...state.appState,
        inactivityLogout: true, // Set inactivity logout state to true
      },
      user: {
        ...state.user,
        userType: undefined,
        logInStatus: {
          isLoggedIn: false,
          hasRedirected: false,
        },
      },
    };
  }

  // Pass action to combined reducers
  return appReducer(state, action);
};

// only persist appState in local storage
const persistConfig = {
  key: 'elevate',
  storage,
  whitelist: ['appState', 'user'],
  // blacklist: ['api', 'auth', 'operatingModel', 'search', 'searchApi', 'user', 'userApi'],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
console.log('Configuring main store...');
const store = configureStore({
  reducer: persistedReducer,
  middleware: [
    selectedReleaseListener.middleware,
    listenerMiddleware.middleware,
    omApi.middleware,
    searchApi.middleware,
    userApi.middleware,
    thunk,
    artifactsApi.middleware,
    changeApi.middleware,
    registrationApi.middleware,
  ],
});

export default store;
export const persistStoreState = persistStore(store);

export type RootState = ReturnType<typeof appReducer>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;
